export default {
  CNY: "￥",
  UST: "$",
  // img host
  sense_id: "1b140c59a6da8e906cb4b7ca6687e075",
  zendesk_key: "4d9be782-15ba-435c-80bd-2df2ded4d2b5",
  // hcaptcha_site_key: {
  //   development: "10000000-ffff-ffff-ffff-000000000001",
  //   production: "572a0d9e-b324-4cf0-8c83-9237bc779cc0",
  // },
  google_analytics_id: "G-2VX4BX8QE2",
  //
  REGIST_TYPE: {
    MOBILE: 1,
    EMAIL: 2,
  },

  // 验证码方式
  CODE_TYPE: {
    BIND_MOBILE: 5,
    BIND_EMAIL: 6,
    BIND_GA: 7,
    UNBIND_EMAIL: 17,
    UNBIND_MOBILE: 18,
    UNBIND_GA: 19,
    CHANGE_BIND_EMAIL: 25,
    CHANGE_BIND_MOBILE: 26,
    CHANGE_BIND_GA: 27,
    CHANGE_BIND_EMAIL_NEW: 28,
    CHANGE_BIND_MOBILE_NEW: 29,
  },

  KYC_TYPE: {
    UNDEFINED: 0,
    PERSON: 1,
    INSTITUTIONS: 2,
  },

  SubBizMap: {
    1000: "STAKING AIRDROP",
    1001: "MINING TB",
    1002: "FILECOIN COMMISSION",
    1003: "TRADE DISCOUNT",
    1004: "CHANNEL TRADE DISCOUNT",
    1005: "CHANNEL TRADE COMMISSION",
    1006: "TRADE COMMISSION",
    1007: "FILジェネマイ収益",
    1008: "FIL PLEDGE INSTREST",
    1009: "XRP RETURN",
    1010: "FIL PLEDGE SAVE",
    1011: "ADIMA CROWN",
    1012: "FIL1Y3 RETURN",
    1013: "CHIAFARMING TB",
    1014: "CHIA COMMISSION",
    1015: "CHIA AWARDS",
    1016: "Chiaファーミング配当",
    1017: "FIL貯蓄型収益",
    1018: "FIL SAVINGS FEE",
  },

  BizMap: {
    0: "",
    1: "トレード",
    2: "出金",
    3: "miPool内送金",
    4: "入金",
    70: "配当",
  },
  CryptoAddressRegrexMap: {
    FIL: "(f[1-3][a-z0-9]{2}[a-z0-9]{6}[a-z0-9]{4}d{4}[a-z0-9]{8}[a-z0-9]{3})",
    XCH: "xch[0-9]{4}[a-z]{7}[0-9]{6}[a-z]{5}[0-9]{3}h[0-9]{2}w+",
    ETH: "0x[0-9a-fA-F]{40}$",
  },
  // UNSHOW_ASSET: [
  //   "CHIAFARMING",
  //   "BMEC",
  //   "BMET",
  //   "ME180",
  //   "ME45",
  //   "ME90",
  //   "FXRP",
  //   "USDH",
  // ],
};
